import _slicedToArray from "/home/runner/work/help/help/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Table/table';
import { css } from '@patternfly/react-styles';
import { Tooltip } from '@patternfly/react-core/dist/esm/components/Tooltip/Tooltip';
export var TableTextVariant;

(function (TableTextVariant) {
  TableTextVariant["div"] = "div";
  TableTextVariant["nav"] = "nav";
})(TableTextVariant || (TableTextVariant = {}));

export var WrapModifier;

(function (WrapModifier) {
  WrapModifier["wrap"] = "wrap";
  WrapModifier["nowrap"] = "nowrap";
  WrapModifier["truncate"] = "truncate";
  WrapModifier["breakWord"] = "breakWord";
  WrapModifier["fitContent"] = "fitContent";
})(WrapModifier || (WrapModifier = {}));

export var TableText = function TableText(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? 'span' : _a$variant,
      _a$wrapModifier = _a.wrapModifier,
      wrapModifier = _a$wrapModifier === void 0 ? null : _a$wrapModifier,
      _a$tooltip = _a.tooltip,
      tooltipProp = _a$tooltip === void 0 ? '' : _a$tooltip,
      _a$tooltipProps = _a.tooltipProps,
      tooltipProps = _a$tooltipProps === void 0 ? {} : _a$tooltipProps,
      _a$onMouseEnter = _a.onMouseEnter,
      onMouseEnterProp = _a$onMouseEnter === void 0 ? function () {} : _a$onMouseEnter,
      props = __rest(_a, ["children", "className", "variant", "wrapModifier", "tooltip", "tooltipProps", "onMouseEnter"]);

  var Component = variant;

  var _React$useState = React.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      tooltip = _React$useState2[0],
      setTooltip = _React$useState2[1];

  var onMouseEnter = function onMouseEnter(event) {
    if (event.target.offsetWidth < event.target.scrollWidth) {
      setTooltip(tooltipProp || event.target.innerText);
    } else {
      setTooltip('');
    }

    onMouseEnterProp(event);
  };

  var text = React.createElement(Component, Object.assign({
    onMouseEnter: onMouseEnter,
    className: css(className, wrapModifier && styles.modifiers[wrapModifier], styles.tableText)
  }, props), children);
  return tooltip !== '' ? React.createElement(Tooltip, Object.assign({
    content: tooltip,
    isVisible: true
  }, tooltipProps), text) : text;
};
TableText.displayName = 'TableText';